import { lazy, Suspense } from "react";
import { Box } from "@mui/material";
import "react-quill/dist/quill.snow.css";

const ReactQuill = lazy(() => import("react-quill"));

type QuillEditorProps = {
  value: string;
  onChange: (value: string) => void;
  modules?: Record<string, unknown>;
  placeholder?: string;
};

const QuillEditor = (props: QuillEditorProps) => (
  <Suspense
    fallback={
      <Box
        sx={{
          minHeight: 120,
          border: "1px solid #e2e8f0",
          borderRadius: 1,
          bgcolor: "#f8fafc",
        }}
      />
    }
  >
    <ReactQuill {...props} />
  </Suspense>
);

export default QuillEditor;
